<!-- 内容审核与上下线 -->
<template>
  <div>
    <bread-crumb></bread-crumb>
    <el-button
      type="primary"
      size="medium"
      :loading="uploadShow"
      @click="setCircle"
      style="width: 93px"
    >
      {{ "新建" }}
    </el-button>
    <div class="search-bar">
      <div class="input-group">
        <el-input
          style="width: 350px"
          v-model="searchParams.communityName"
          placeholder="请输入圈子名称"
          clearable
        ></el-input>
        <el-input
          style="width: 350px"
          v-model="searchParams.communityId"
          placeholder="请输入圈子ID"
          clearable
        ></el-input>
        <el-input
          style="width: 350px"
          v-model="searchParams.labelName"
          placeholder="请输入运营标签"
          clearable
        ></el-input>
        <el-select
          style="width: 350px"
          v-model="searchParams.communityType"
          placeholder="请选择圈子类型"
          clearable
        >
          <el-option label="疾病圈" value="疾病圈"></el-option>
          <el-option label="症状圈" value="症状圈"></el-option>
          <el-option label="药品圈" value="药品圈"></el-option>
          <el-option label="兴趣圈" value="兴趣圈"></el-option>
          <el-option label="情趣圈" value="情趣圈"></el-option>
          <el-option label="轻盈圈" value="轻盈圈"></el-option>
        </el-select>
      </div>
      <div class="button-group">
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </div>
    </div>
    <div class="content-audit-tabel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all">
          <span slot="label" class="slot-item">
            <span>全部</span>
            <!-- todo -->
            <!-- <span>{{ allCount }}</span> -->
          </span>
          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></circle-table>
        </el-tab-pane>
        <el-tab-pane label="待上线" name="pending">
          <span slot="label" class="slot-item">
            <span>待上线</span>
            <!-- todo -->
            <!-- <span>{{ unAuditCount }}</span> -->
          </span>
          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></circle-table>
        </el-tab-pane>
        <!-- <el-tab-pane label="待下线审核" name="offlineEview">
          <span slot="label" class="slot-item">
            <span>待下线审核</span><span>{{ offlineUnAuditCount }}</span>
          </span>
          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></circle-table>
        </el-tab-pane> -->
        <el-tab-pane label="已上线" name="online">
          <span slot="label" class="slot-item">
            <span>已上线</span>
            <!-- todo -->
            <!-- <span>{{ passAuditCount }}</span> -->
          </span>
          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></circle-table>
        </el-tab-pane>
        <el-tab-pane label="已下线" name="offline">
          <span slot="label" class="slot-item">
            <span>已下线</span>
            <!-- todo -->
            <!-- <span>{{ offlineCount }}</span> -->
          </span>
          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></circle-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--新建圈子-->
    <el-dialog
      title="新建圈子"
      :visible.sync="dialogSetCircle"
      width="50%"
      @close="closeOutDialog"
    >
      <div style="margin-top: 10px">
        <el-form :model="circleForm" :rules="circleRules" ref="circleForm">
          <!-- 名称 -->
          <el-form-item
            label="圈子名称"
            label-width="120px"
            prop="communityName"
          >
            <el-input v-model="circleForm.communityName"></el-input>
          </el-form-item>

          <!-- 小图 -->
          <el-form-item
            label="圈子小图"
            label-width="120px"
            prop="communityPicUrl"
          >
            <!-- 小图 -->
            <upload-img-universal
              @change-title-pic="changeTitlePic"
              :data="circleForm.communityPicUrl"
            />
          </el-form-item>

          <!-- 类型 -->
          <el-form-item
            label="圈子类型"
            label-width="120px"
            prop="communityType"
          >
            <el-select
              v-model="circleForm.communityType"
              placeholder="请选择类型"
            >
              <el-option label="兴趣圈" value="兴趣圈"></el-option>
              <el-option label="情趣圈" value="情趣圈"></el-option>
              <el-option label="轻盈圈" value="轻盈圈"></el-option>
            </el-select>
          </el-form-item>

          <!-- todo: 分类 -->
          <el-form-item
            v-if="publicDomain"
            label="圈子分类"
            label-width="120px"
            prop="categoryId"
          >
            <el-select v-model="circleForm.categoryId" placeholder="请选择类型">
              <el-option
                v-for="item in this.categoryList"
                :key="item.categoryId"
                :label="item.categoryName"
                :value="item.categoryId"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- todo: 排序 -->
          <el-form-item
            v-if="publicDomain"
            label="分类排序"
            label-width="120px"
            prop="rankNum"
          >
            <el-input-number
              v-model="circleForm.rankNum"
              :min="0"
              :max="1000"
            ></el-input-number>
          </el-form-item>
          <!-- todo: 标签 -->
          <el-form-item
            v-if="publicDomain"
            label="运营标签"
            label-width="120px"
            prop="labelName"
          >
            <article-label
              :labelType="$route.query.tenantid == '287' ? 1 : undefined"
              :functionIds="{
                getArticleLabel: 'health_cmp_biz_pageAuditLabels',
              }"
              ref="labelRef"
              @label-change="handleLabelChange"
            />
          </el-form-item>

          <!-- todo: 热门 -->
          <el-form-item
            v-if="publicDomain"
            label="热门圈子"
            label-width="120px"
          >
            <el-radio-group v-model="circleForm.isHot">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- todo: 功能 -->
          <el-form-item
            v-if="publicDomain"
            label="功能模块及策略配置"
            label-width="120px"
            prop="features"
            style="text-align: left"
            class="largeLabel"
          >
            <el-form-item>
              <el-checkbox
                v-model="circleForm.video"
                disabled
                label="视频"
              ></el-checkbox>
              <el-input
                v-if="circleForm.video"
                v-model="circleForm.videoVal"
                :placeholder="circlePlaceholders.video"
                style="margin-left: 20px; width: 80%"
              ></el-input>
              <upload-video
                v-if="circleForm.video"
                @changeVideo="changeVideos"
                :functionIds="{
                  queryEncyclopedia: 'health_cmp_biz_c_queryContentDetail',
                }"
              />
            </el-form-item>
            <el-form-item>
              <el-checkbox
                v-model="circleForm.circle"
                disabled
                label="圈子"
              ></el-checkbox>
            </el-form-item>
            <el-form-item
              v-if="
                circleForm.communityType == '疾病圈' ||
                circleForm.communityType == '症状圈'
              "
            >
              <el-checkbox
                v-model="circleForm.baike"
                disabled
                label="百科"
              ></el-checkbox>
              <el-input
                v-if="circleForm.baike"
                v-model="circleForm.baikeVal"
                :placeholder="circlePlaceholders.baike"
                style="margin-left: 20px; width: 80%"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="circleForm.communityType == '药品圈'">
              <el-checkbox
                v-model="circleForm.instruction"
                disabled
                label="用药指导"
              ></el-checkbox>
              <!-- <el-input v-if="circleForm.instruction"
                v-model="circleForm.instructionVal"
                :placeholder="circlePlaceholders.instruction"
                style="margin-left: 20px; width: 80%;"
              ></el-input> -->
            </el-form-item>
            <el-form-item v-if="circleForm.communityType == '药品圈'">
              <el-checkbox
                v-model="circleForm.priceParity"
                disabled
                label="比价"
              ></el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-checkbox
                v-model="circleForm.doctor"
                disabled
                label="问医生"
              ></el-checkbox>
              <el-input
                v-if="circleForm.doctor"
                v-model="circleForm.doctorVal"
                :placeholder="circlePlaceholders.doctor"
                style="margin-left: 20px; width: 80%"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox
                v-model="circleForm.goods"
                disabled
                label="推荐好物"
              ></el-checkbox>
              <el-input
                v-if="circleForm.goods"
                v-model="circleForm.goodsVal"
                :placeholder="circlePlaceholders.goods"
                style="margin-left: 20px; width: 80%"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item v-for="feature in additionalFeatures" :key="feature">
              {{ feature }}
              <el-checkbox v-model="circleForm.features[features]" :label="feature"></el-checkbox>
              <el-input v-if="circleForm?.features && circleForm?.features.includes(feature) && feature !== '圈子'"
                v-model="circleForm.featureInputs[feature]"
                :placeholder="circlePlaceholders[feature]"
                style="margin-left: 20px; width: 80%;"
              ></el-input>

            </el-form-item> -->
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSetCircle = false">取消</el-button>
        <el-button type="primary" @click="handleConfirm">创建</el-button>
      </div>
    </el-dialog>
    <!--编辑圈子-->
    <el-dialog
      title="编辑圈子"
      :visible.sync="dialogEditCircle"
      width="50%"
      @close="closeOutDialog"
    >
      <div style="margin-top: 10px">
        <el-form :model="circleForm" :rules="circleRules" ref="circleForm">
          <!-- 名称 -->
          <el-form-item
            label="圈子名称"
            label-width="120px"
            prop="communityName"
          >
            <el-input v-model="circleForm.communityName"></el-input>
          </el-form-item>
          <el-form-item
            v-if="circleForm.communityType == '疾病圈'"
            label="百科ID"
            label-width="120px"
            prop="communityName"
          >
            {{ circleForm.baikeContentId }}
          </el-form-item>
          <el-form-item
            v-if="circleForm.communityType == '疾病圈'"
            label="疾病标签"
            label-width="120px"
            prop="communityName"
          >
            <disease-label
              :data="circleForm.diseaseLabels"
              @changeDiseaseLabels="changeDiseaseLabels"
            ></disease-label>
            <!-- <el-input v-model="circleForm.communityName"></el-input> -->
          </el-form-item>
          <el-form-item
            v-if="circleForm.communityType == '症状圈'"
            label="百科ID"
            label-width="120px"
            prop="communityName"
          >
            {{ circleForm.baikeContentId }}
          </el-form-item>
          <el-form-item
            v-if="circleForm.communityType == '症状圈'"
            label="症状标签"
            label-width="120px"
            prop="communityName"
          >
            <symptom-label
              :csdata="circleForm.contentSymptoms"
              @changeSymptomLabels="changeSymptomLabels"
              :functionIds="{ getSymptom: 'health_cmp_pageSymptomByName' }"
              ref="symptomRef"
            />
            <!-- <el-input v-model="circleForm.communityName"></el-input> -->
          </el-form-item>
          <!-- todo: 药品圈 -->
          <!-- <el-form-item v-if="circleForm.communityType == '药品圈'" label="药品俗名" label-width="120px" prop="communityName"> -->
          <!-- <Drug-id-label 
              :data="circleForm.nativeName"
              @changeEncyclopediaLabels="changeEncyclopediaLabels"
              :is-show-encyclopedia="isShowEncyclopedia"
              :functionIds="{
                queryEncyclopedia: 'health_cmp_biz_manPageDrugInfoByParam'
              }"/> -->
          <!-- <el-input v-model="circleForm.nativeName"></el-input> -->
          <!-- </el-form-item> -->
          <!-- <el-form-item v-if="circleForm.communityType == '药品圈'" label="药品通用名" label-width="120px" prop="communityName"> -->
          <!-- 常用名  -->
          <!-- <Generic-name-label
              :data="circleForm.contentDrugNames"
              @changeGenericNameLabels="changeGenericNameLabels"
              :is-show-encyclopedia="isShowEncyclopedia"
              :functionIds="{
                queryEncyclopedia: 'health_cmp_biz_queryDrugGenericNames'
              }"/> -->
          <!-- <el-input v-model="circleForm.communityName"></el-input> -->
          <!-- </el-form-item> -->
          <!-- 小图 -->
          <!-- todo -->
          <!-- {{ circleForm.communityPicUrl }} -->
          <el-form-item
            label="圈子小图"
            label-width="120px"
            prop="communityPicUrl"
          >
            <!-- <el-upload
              class="upload-demo"
              action="/imageUpload.action"
              :show-file-list="false"
              :http-request="httpRequestEditor"
              accept="image/png, image/jpeg,image/gif"
            >
              <el-button size="small" type="primary" ref="uploadImage"
              >点击上传</el-button
              >
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div>
            </el-upload> -->
            <!-- 小图 -->
            <upload-img-universal
              @change-title-pic="changeTitlePic"
              :data="circleForm.communityPicUrl"
            />
            <!-- <span class="el-upload__tip">
                图片尺寸不低于100x100
            </span> -->
            <!-- <div class="personal-center-from-right">
              <div class="personal-center-from-right-top">
                <div class="font"><span class="icon">*</span> 头像</div>
                <div class="img">
                  <div class="demo-basic--circle">
                    <div class="block">
                      <el-avatar :size="70" :src="imgUrl?imgHost+imgUrl:defaultImage" :key="imgHost+imgUrl"></el-avatar>
                    </div>
                  </div>
                  <div class="upload">
                    <el-upload ref="fileUpload" class="upload-demo" action="/imageUpload.action" :auto-upload="false" :http-request="httpRequest" :on-change='onImgChange' :before-upload="checkFile" accept="image/png, image/jpeg,image/gif,image/jpg,image/bmp,image/heic" :limit="1" :file-list="fileList">
                      <el-button size="small" type="primary">上传头像</el-button>
                    </el-upload>
                  </div>
                </div>
              </div>
              <div class="personal-center-from-right-bottom">
                <i class="el-icon-warning"></i>
                建议尺寸不低于180*180像素，大小不超过1M
              </div>
            </div> -->
          </el-form-item>

          <!-- 类型 -->
          <el-form-item
            label="圈子类型"
            label-width="120px"
            prop="communityType"
          >
            <el-select
              v-model="circleForm.communityType"
              :disabled="true"
              placeholder="请选择类型"
            >
              <el-option label="疾病圈" value="疾病圈"></el-option>
              <el-option label="症状圈" value="症状圈"></el-option>
              <el-option label="药品圈" value="药品圈"></el-option>
              <el-option label="兴趣圈" value="兴趣圈"></el-option>
              <el-option label="情趣圈" value="情趣圈"></el-option>
              <el-option label="轻盈圈" value="轻盈圈"></el-option>
            </el-select>
          </el-form-item>
          <!-- 分类 -->
          <el-form-item
            v-if="publicDomain"
            label="圈子分类"
            label-width="120px"
            prop="categoryId"
          >
            <el-select v-model="circleForm.categoryId" placeholder="请选择类型">
              <el-option
                v-for="item in this.categoryList"
                :key="item.categoryId"
                :label="item.categoryName"
                :value="item.categoryId"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- todo: 排序 -->
          <el-form-item
            v-if="publicDomain"
            label="分类排序"
            label-width="120px"
            prop="rankNum"
          >
            <el-input-number
              v-model="circleForm.rankNum"
              :min="0"
              :max="1000"
            ></el-input-number>
          </el-form-item>
          <!-- <el-form-item v-if="circleForm.communityType == '药品圈'" label="药品俗名" label-width="120px" prop="communityName"> -->
          <!-- <el-input v-model="circleForm.communityName"></el-input> -->
          <!-- </el-form-item> -->
          <!-- <el-form-item v-if="circleForm.communityType == '药品圈'" label="药品通用名" label-width="120px" prop="communityName"> -->
          <!-- <el-input v-model="circleForm.communityName"></el-input> -->
          <!-- </el-form-item> -->
          <!-- todo: 标签 -->
          <!-- <el-form-item label="运营标签" label-width="120px" prop="type">
            <el-select v-model="circleForm.type" placeholder="请选择运营类型">
              <el-option label="类型A" value="A"></el-option>
              <el-option label="类型B" value="B"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item
            v-if="publicDomain"
            label="运营标签"
            label-width="120px"
            prop="labelName"
          >
            <article-label
              :labelType="$route.query.tenantid == '287' ? 1 : undefined"
              :functionIds="{
                getArticleLabel: 'health_cmp_biz_pageAuditLabels',
              }"
              ref="labelRef"
              :myIds="circleForm.extensionContentLabels"
              @label-change="handleLabelChange"
              :key="componentKey"
            />
          </el-form-item>
          <!-- todo: 热门 -->
          <el-form-item
            v-if="publicDomain"
            label="热门圈子"
            label-width="120px"
          >
            <el-radio-group v-model="circleForm.isHot">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- todo: 功能 -->
          <!-- <el-form-item label="功能模块及策略配置" label-width="120px" prop="features">
            <el-form-item v-for="feature in additionalFeatures" :key="feature">
              <el-checkbox v-model="circleForm.features" :label="feature"></el-checkbox>
              <el-input v-if="circleForm.features.includes(feature) && feature !== '圈子'"
                v-model="circleForm.featureInputs[feature]"
                :placeholder="circlePlaceholders[feature]"
                style="margin-left: 20px; width: 80%;"
              ></el-input>
              <upload-video
                v-if="circleForm.features.includes(feature) && feature === '视频'"
                :functionIds="{
                  queryEncyclopedia: 'health_cmp_biz_queryDrugGenericNames'
                }"/>
            </el-form-item>
          </el-form-item> -->
          <!-- todo: 功能 -->
          <el-form-item
            v-if="publicDomain"
            label="功能模块及策略配置"
            label-width="120px"
            prop="features"
            class="largeLabel"
          >
            <el-form-item>
              <el-checkbox
                v-model="circleForm.video"
                disabled
                label="视频"
              ></el-checkbox>
              <el-input
                v-if="circleForm.video"
                v-model="circleForm.videoVal"
                :placeholder="circlePlaceholders.video"
                style="margin-left: 20px; width: 80%"
              ></el-input>
              <upload-video
                v-if="circleForm.video"
                :data="circleForm.videoAll"
                :functionIds="{
                  queryEncyclopedia: 'health_cmp_biz_c_queryContentDetail',
                }"
              />
            </el-form-item>
            <el-form-item>
              <el-checkbox
                v-model="circleForm.circle"
                disabled
                label="圈子"
              ></el-checkbox>
            </el-form-item>
            <el-form-item v-if="circleForm.communityType != '药品圈'">
              <el-checkbox
                v-model="circleForm.doctor"
                disabled
                label="问医生"
              ></el-checkbox>
              <el-input
                v-if="circleForm.doctor"
                v-model="circleForm.doctorVal"
                :placeholder="circlePlaceholders.doctor"
                style="margin-left: 20px; width: 80%"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="circleForm.communityType != '药品圈'">
              <el-checkbox
                v-model="circleForm.goods"
                disabled
                label="推荐好物"
              ></el-checkbox>
              <el-input
                v-if="circleForm.goods"
                v-model="circleForm.goodsVal"
                :placeholder="circlePlaceholders.goods"
                style="margin-left: 20px; width: 80%"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item 
               v-if="circleForm.communityType == '疾病圈' || circleForm.communityType == '症状圈'"
            >
              <el-checkbox
                v-model="circleForm.baike" disabled label="百科">
              </el-checkbox>
                <el-input v-if="circleForm.baike"
                v-model="circleForm.baikeVal"
                :placeholder="circlePlaceholders.baike"
                style="margin-left: 20px; width: 80%;"
                ></el-input> 
            </el-form-item> -->
            <el-form-item v-if="circleForm.communityType == '药品圈'">
              <el-checkbox
                v-model="circleForm.instruction"
                disabled
                label="用药指导"
              ></el-checkbox>
              <!-- <el-input v-if="circleForm.instruction"
                v-model="circleForm.instructionVal"
                :placeholder="circlePlaceholders.instruction"
                style="margin-left: 20px; width: 80%;"
              ></el-input> -->
            </el-form-item>
            <el-form-item v-if="circleForm.communityType == '药品圈'">
              <el-checkbox
                v-model="circleForm.priceParity"
                disabled
                label="比价"
              ></el-checkbox>
            </el-form-item>
            <!-- <el-form-item v-for="feature in additionalFeatures" :key="feature">
              {{ feature }}
              <el-checkbox v-model="circleForm.features[features]" :label="feature"></el-checkbox>
              <el-input v-if="circleForm?.features && circleForm?.features.includes(feature) && feature !== '圈子'"
                v-model="circleForm.featureInputs[feature]"
                :placeholder="circlePlaceholders[feature]"
                style="margin-left: 20px; width: 80%;"
              ></el-input>

            </el-form-item> -->
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEditCircle = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <base-dialog
      :dialogShow="offlineDialogShow"
      @dialogHandel="offlineDialogHandel"
      :formData="formData"
      @closeDialog="offlineCloseDialog"
    ></base-dialog>
  </div>
</template>

<script>
import circleTable from "./circleTable.vue";
// import search from "../../../components/search"
import manFormList from "../../../components/manFormList";
import breadCrumb from "../../../../../components/breadCrumb";
import pagination from "../../../../../components/pagination";
import {
  passOfflineArticle,
  listContentBusinessForUserMan,
  manSaveUserConfig,
  manListUserConfig,
} from "@/api/man";
import { jdh_qz_man_page } from "../../../../../api/community";
import {
  jdh_qz_man_add,
  jdh_qz_man_update,
  jdh_qz_man_queryCategorys,
  jdh_qz_man_detail,
} from "../../../../../api/community";
// import {queryCommunityList} from "../../../../../api/community";
import modal from "@/components/modal";
import baseDialog from "../../../components/baseDialog";
import { getDiseasesData } from "../distribution";
import { request } from "@/utils/axios";
import {
  getDistributionScope,
  searchDataProcessing,
  getContentQuailty,
  getContentSources,
} from "../distribution";
import { manListContentIndexTree } from "@/api/indexs";
import {
  getOutArticleCategory,
  uploadCategoryExl,
  fileChange,
} from "../../../components/importExportCommon";
import diseaseLabel from "./diseaseLable.vue";
import { getImportTemplate } from "@/api/man";
import { mapState } from "vuex";
import uploadImage from "@/components/uploadImage";
import uploadPosterImage from "@/components/upload/uploadPosterImage";
import uploadImgUniversal from "@/components/upload/uploadImgUniversal";
import GenericNameLabel from "./GenericNameLabel";
import UploadVideo from "@/components/combination/UploadVideo";
import SymptomLabel from "./SymptomLabel.vue";
import ArticleLabel from "./ArticleLabel";
import DrugIdLabel from "./DrugIdLabel.vue";
import { getBusinessId } from "../../../../../utils/enum";
// import mock from "./mock.json";

export default {
  name: "circleManage",
  data() {
    return {
      tenantId: this.$commonJs.getTenantId(),
      num: 3,
      rejectForm: {
        rejectlineDialog: false,
        rejectReasons: "",
        applyReason: "",
        isShowBtn: [true, true], //弹窗是否能显示按钮
        ordinaryBtnText: ["取消", "确认"],
      },
      activeName: "all",
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "圈子ID",
            prop: "communityId",
            width: "180px",
          },
          {
            label: "圈子名称",
            prop: "communityName",
            width: "200px",
          },
          {
            label: "圈子类型",
            prop: "communityTypeCheck",
          },
          {
            label: "运营标签",
            prop: "CommunityLabelInfo",
          },
          {
            label: "圈子模块",
            prop: "communityCatagory",
          },
          // 0：创建；1：上线；2：下线
          {
            label: "状态",
            prop: "statusCheck",
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: "120px",
          },
          {
            label: "上线时间",
            prop: "onlineTime",
            width: "120px",
          },
          {
            label: "创建人",
            prop: "createUser",
            width: "130px",
          },
        ],
        tableType: 111,
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      articleStatus: [],
      articleListCode: 0,
      allCount: 0, // 全部
      offlineCount: 0, // 已下线
      offlineUnAuditCount: 0, // 下线待审核
      passAuditCount: 0, // 已通过
      rejectCount: 0, // 驳回
      unAuditCount: 0, // 待审核
      isShowBtn: [true, true, false],
      reviewOfflineDialog: false, // 审核下线申请
      btnText: ["驳回", "通过"],
      targetValue: null,
      isSelected: false,
      formData: {
        formList: {
          title: "下线文章",
          infoKey: "下线理由",
          infoValue: "",
          placeholder: "请输入下线理由",
          maxlength: "200",
          type: 2, //0(13\16) or 1(28)
        },
      },
      offlineDialogShow: false,
      formlist: [],
      old: {},
      isBtn: 1,
      isShowFilter: 1,
      searchFilterList: [],
      configId: null,
      checkList: [1000],
      allSearchList: [],
      serverList: [],
      contentAttributes: [],
      rangeList: [], // 分发范围
      qualityList: [], // 内容质量
      businessList: [],
      articleLabels: [], // 内容标签
      businessChannelArr: [],
      select: [
        {
          prop: "communityName",
          type: "input2",
          placeholder: "请输入圈子名称",
          maxLenth: 18,
        },
        {
          prop: "communityId",
          type: "input2",
          placeholder: "请输入圈子ID",
          maxLenth: 18,
        },
        {
          prop: "communityType",
          type: "input2",
          placeholder: "请输入圈子类型",
          maxLenth: 18,
        },
        // todo
        // {
        //   prop: 'articleId',
        //   type: 'input2',
        //   placeholder: '请输入运营标签',
        //   maxLenth: 18,
        // }
      ],
      isButton: false,
      uploadShow: false,
      timer: null,
      // 新建圈子
      dialogSetCircle: false,
      // 编辑圈子
      dialogEditCircle: false,
      // 增加主视频
      dialogAddVideo: false,
      contentType: "1",
      questionFrom: [], // 记录内容来源
      circleForm: {
        communityName: "",
        communityPicUrl: "",
        type: "",
        categoryName: "",
        rankNum: "",
        communityType: "兴趣圈",
        isHot: false,
      },
      circleRules: {
        communityName: [
          { required: true, message: "请输入圈子名称", trigger: "blur" },
        ],
        communityType: [
          { required: true, message: "请选择圈子类型", trigger: "blur" },
        ],
        features: [
          { required: true, message: "请选择圈子类型", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              if (
                !(
                  this.circleForm.video ||
                  this.circleForm.circle ||
                  this.circleForm.doctor ||
                  this.circleForm.goods
                )
              ) {
                callback(new Error("圈子类型不能为空"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      additionalFeatures: [
        "视频",
        "圈子",
        "问医生",
        "推荐好物",
        "百科",
        "用药指导",
        "比价",
      ],
      circlePlaceholders: {
        video: "请输入关键词，多个关键词‘;‘隔开",
        doctor: "请输入医生搜索关键词",
        goods: "请输入商品搜索关键词",
        baike: "请输入百科",
        instruction: "请输入用药指导",
        priceParity: "请输入比价",
      },
      titlePicUrl: [],
      searchParams: {
        communityName: "",
        communityId: "",
        communityType: "",
      },
      communityTypeMap: {
        0: "疾病圈",
        1: "症状圈",
        2: "药品圈",
        3: "兴趣圈",
        4: "情趣圈",
        5: "轻盈圈",
        6: "普法圈",
      },
      statusMap: {
        0: "待上线",
        1: "上线",
        2: "下线",
      },
      categoryList: [],
      componentKey: 0,
      targetObj: {},
      publicDomain: false,
    };
  },
  components: {
    // search,
    manFormList,
    breadCrumb,
    circleTable,
    pagination,
    modal,
    baseDialog,
    uploadPosterImage,
    uploadImage,
    uploadImgUniversal,
    GenericNameLabel,
    DrugIdLabel,
    UploadVideo,
    diseaseLabel,
    ArticleLabel,
    SymptomLabel,
  },
  watch: {
    "circleForm.extensionContentLabels": {
      handler(newVal, oldVal) {
        // 触发组件刷新
        this.refreshComponent();
      },
      deep: true, // 如果 extensionContentLabels 是一个对象或数组，使用 deep 监听
    },
    // 'circleForm.changeSymptomLabels': {
    //   handler(newVal, oldVal) {
    //     // 触发组件刷新
    //     this.refreshComponent();
    //   },
    //   deep: true // 如果 changeSymptomLabels 是一个对象或数组，使用 deep 监听
    // }
  },
  async created() {
    // console.log('开始=========》');
    // 查询用户保存配置
    await this.queryUserConfig();
    //  获取天空之城数据
    await this.queryFloorList();
    //  console.log('结束=========》');
    // 获取分发范围
    this.getDistributionScope();
    // 获取内容质量
    this.getContentQuailty();
    // sessionStorage获取tabpane的状态
    this.getSessionStorageInfo();
    // this.getArticleList()
    this.listContentBusinessForUserMan();
    this.getIndexTreeList();
    getContentSources(this);
  },
  mounted() {
    this.$nextTick(() => {
      // 添加这段代码
      const $el = document.querySelectorAll(
        ".el-cascader-panel .el-cascader-node[aria-owns]"
      );
      Array.from($el)?.map((item) => item.removeAttribute("aria-owns"));
    });
    this.getCategoryList();
    this.publicDomain =
      parseInt(this.$route.query.tenantid) != 484 &&
      parseInt(this.$route.query.tenantid) != 492 &&
      parseInt(this.$route.query.tenantid) != 501;
  },
  destroyed() {
    // 销毁详情跳跳转存储
    sessionStorage.removeItem("content");
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
  methods: {
    getBusinessId(key) {
      return getBusinessId(key);
    },
    refreshComponent() {
      // 通过改变 key 强制重新渲染组件
      this.componentKey += 1;
    },
    recursionObj(node, callback, judge) {
      if (judge(node)) {
        node = callback(node);
      }
      if (!node.contentIndexes || node.contentIndexes.length === 0) {
        return;
      }
      for (let i = 0; i < node.contentIndexes.length; i++) {
        if (judge(node)) {
          this.recursionObj(node.contentIndexes[i], callback, () => true);
        } else {
          this.recursionObj(node.contentIndexes[i], callback, judge);
        }
      }
      return;
    },
    importChangeFn(v) {
      console.log("importChangeFn", v);
      if (v == 1) {
        this.dialogInContentSkusVisible = true;
      } else if (v == 2) {
        this.dialogInCategoryVisible = true;
      }
    },
    exportChangeFn(v) {
      console.log("exportChangeFn", v);
      if (v == 1) {
        this.dialogOutContentSkusVisibleSku = true;
      } else if (v == 2) {
        this.dialogOutCategoryVisible = true;
      } else if (v == 3) {
        this.downloadDiles(8);
      } else if (v == 4) {
        this.downloadDiles(7);
      } else if (v == 5) {
        this.downloadDiles(5);
      } else if (v == 6) {
        this.downloadDiles(4);
      } else if (v == 7) {
        this.downloadDiles(2);
      }
    },
    // 获取索引下拉数据
    getIndexTreeList() {
      manListContentIndexTree().then((res) => {
        // 处理树的叶子结点
        for (let i = 0; i < res.length; i++) {
          this.recursionObj(
            res[i],
            (curNode) => {
              curNode.contentIndexes = undefined;
              return curNode;
            },
            (node) => node.contentIndexes.length === 0
          );
        }
        this.indexTreeList = res;
        this.select?.map((subItem) => {
          if (subItem.prop == "contentIndexIds") {
            subItem.List = res;
          }
        });
      });
    },
    // 上传弹窗关闭
    closeDialog() {
      let fileVal = this.$refs.file;
      fileVal.value = "";
      this.fileResult = "";
      this.fileName = "";
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    //导出弹窗关闭
    closeOutDialog() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 下载模板或失败数据
    downloadDiles(type) {
      if (type == 3) {
        this.isButton = true;
        window.open(
          "//storage.360buyimg.com/cms-bucket/ImportTemplate/%E5%AF%BC%E5%85%A5%E5%86%85%E5%AE%B9%E5%85%B3%E8%81%94%E7%B1%BB%E7%9B%AE%E6%A8%A1%E6%9D%BF.xlsx?Expires=3810106704&AccessKey=Jd9HhkNEAtwojp2B&Signature=XtmgTIEu8TAo8ygsLoa1GfgZ%2Faw%3D"
        );
        setTimeout(() => {
          this.isButton = false;
        }, 3000);
      }
      if (type == 4) {
        window.open(this.failImportUrl);
        this.isImportErrorShow = false;
      }
      if (type == 5) {
        window.open(this.failExportUrl);
        this.isExportErrorShow = false;
      }
      if (type == 7) {
        window.open(this.failImportSaleUrl);
        this.isSaleImportErrorShow = false;
      }
      if (type == 8) {
        window.open(this.failExportSaleUrl);
        this.isSaleExportErrorShow = false;
      }
      if (type == 6) {
        window.open(this.failExportArticleUrl);
        this.isExportArticleShow = false;
      }
      if (type === 9) {
        this.isButton = true;
        window.open(
          "//storage.jd.com/cms-bucket/importExcel/9/ImportTemplate/contentSkuImportTemplate.xlsx?Expires=3833524642&AccessKey=Jd9HhkNEAtwojp2B&Signature=txKqNOai4LeYgVImYsd%2BzzU92RI%3D"
        );
        setTimeout(() => {
          this.isButton = false;
        }, 3000);
      }
      if (type === this.videoImportExportCode) {
        this.isButton = true;
        getImportTemplate({
          importExportCode: type,
        }).then((res) => {
          if (res.templateUrl) {
            const excelUrl = res.templateUrl.replace(
              "http://storage.jd.local",
              "https://storage.360buyimg.com"
            );
            window.location.href = excelUrl;
            this.$message.success(`下载成功`);
          }
        });
        setTimeout(() => {
          this.isButton = false;
        }, 3000);
      }
    },

    // 上传文件校验
    async fileChange(e) {
      fileChange(e, this);
    },
    // 上传类目
    async uploadCategoryExl() {
      uploadCategoryExl(this, 1);
    },
    // 文章导出
    getOutArticleCategory() {
      getOutArticleCategory(this, 5);
    },
    // 导出类目
    async getOutContentCategory() {
      getOutArticleCategory(this, 1);
    },
    // 导出商品
    async getOutContentContentSkus() {
      getOutArticleCategory(this, 9);
    },
    // 上传商品
    async uploadContentSkusExl() {
      uploadCategoryExl(this, 9);
    },
    // 视频免审
    async uploadVideoExl() {
      uploadCategoryExl(this, this.videoImportExportCode);
    },
    // 查询疾病库名称
    getDiseases(val) {
      getDiseasesData(val, this);
    },
    // 跳转存储信息
    setStorage() {
      // 跳转页面存储当前页码
      sessionStorage.setItem(
        "currentPage",
        this.paginationDataProduct.currentPage
      );
      sessionStorage.setItem("activeName", this.activeName);
      // sessionStorage.setItem('select', selectStr)
    },
    getSessionStorageInfo() {
      this.activeName = sessionStorage.getItem("activeName") || "all";
      if (this.activeName === "all") {
        this.articleListCode = 0;
      } else if (this.activeName === "pending") {
        this.articleListCode = 0;
      } else if (this.activeName === "online") {
        this.articleListCode = 1;
      } else if (this.activeName === "offline") {
        this.articleListCode = 2;
      } else {
        console.log("==== error", this.activeName);
        this.activeName = "all";
        this.articleListCode = 0;
        this.searchParams.status = "";
      }
      this.articleStatus = [];
      if (this.articleListCode !== 0) {
        this.articleStatus.push(this.articleListCode);
      }
      this.getArticleList();
    },
    // 处理切换列表（按状态筛选）
    handleClick(tab, event) {
      sessionStorage.setItem("activeName", tab.name);
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      // this.getArticleList()
      if (this.activeName === "all") {
        this.articleListCode = 0;
        this.searchParams.status = "";
      } else if (this.activeName === "pending") {
        this.articleListCode = 0;
        this.searchParams.status = 0;
      } else if (this.activeName === "online") {
        this.articleListCode = 1;
        this.searchParams.status = 1;
      } else if (this.activeName === "offline") {
        this.articleListCode = 2;
        this.searchParams.status = 2;
      }
      this.articleStatus = [];
      if (this.articleListCode !== 0) {
        console.log(
          "=========",
          tab.name,
          this.articleListCode,
          this.articleStatus
        );
        this.articleStatus.push(this.articleListCode);
      }

      this.getArticleList();
    },
    // 操作逻辑
    TabhandleClick(val) {
      if (val.type === "edit") {
        console.log("=====EDIT", val);
        // this.setStorage()
        this.currentDetail = val;
        // 请求详情接口
        jdh_qz_man_detail({
          tenantId: this.tenantId,
          businessId: this.getBusinessId(this.tenantId),
          communityId: val.val.communityId,
        }).then((res) => {
          this.targetObj = res;
          console.log("=== detail", res);
          const communityConfJson = res?.communityConfJson
            ? JSON.parse(res?.communityConfJson)
            : {};
          const contentVideo = res?.communityContent?.contentVideo;
          console.log("=====VIDEO DETAIL", contentVideo);
          console.log("??final CIRCLE", this.circleForm);
          this.dialogEditCircle = true;
          setTimeout(() => {
            // console.log("======!!",res.communityPicUrl)
            this.circleForm = {
              communityId: res.communityId,
              communityName: res.communityName,
              communityPicUrl: res.communityPicUrl ? res.communityPicUrl : "",
              communityType: this.communityTypeMap[res.communityType],
              categoryId: res.categoryId,
              rankNum: res?.rankNum,
              isHot: res.isHot == 1 ? true : false,
              rankNum: res.rankNum,
              status: res.status,
              categoryName: res.categoryName,
              // extensionContentLabels: (res?.communityLabelInfos && res?.communityLabelInfos.length > 0) ? res?.communityLabelInfos.map(label => label.labelId) : [],
              extensionContentLabels: [],
              diseaseLabels: [],
              contentSymptoms: [],
              nativeName: "",
              contentDrugNames: [],
              // 更改id字段
              videoAll: contentVideo
                ? [
                    {
                      title: contentVideo?.videoName,
                      playUrl: contentVideo?.playUrl,
                      videoId: res?.communityContent?.contentId,
                    },
                  ]
                : [],
              video: true,
              videoVal: communityConfJson
                ? communityConfJson?.module?.video?.keywords
                : "",
              contentId: communityConfJson
                ? communityConfJson?.module?.video.contentId
                : "",
              playUrl: communityConfJson
                ? communityConfJson?.module?.video.playUrl
                : "",
              doctor:
                this.communityTypeMap[res.communityType] != "药品圈"
                  ? true
                  : false,
              doctorVal: communityConfJson
                ? communityConfJson?.module?.doctor?.keywords
                : "",
              circle: true,
              goods:
                this.communityTypeMap[res.communityType] != "药品圈"
                  ? true
                  : false,
              goodsVal: communityConfJson
                ? communityConfJson?.module?.recommend?.keywords
                : "",
              baike:
                this.communityTypeMap[res.communityType] == "疾病圈" ||
                this.communityTypeMap[res.communityType] == "症状圈"
                  ? true
                  : false,
              baikeVal: communityConfJson
                ? communityConfJson?.module?.baike?.keywords
                : "",
              baikeContentId: res?.baikeContentId || "",
              instruction:
                this.communityTypeMap[res.communityType] == "药品圈"
                  ? true
                  : false,
              priceParity:
                this.communityTypeMap[res.communityType] == "药品圈"
                  ? true
                  : false,
            };
            // 反解标签
            if (res.communityLabelInfos) {
              res.communityLabelInfos.forEach((item) => {
                if (item.labelType === 1) {
                  this.circleForm.extensionContentLabels.push(item.labelId);
                } else if (item.labelType === 2) {
                  this.circleForm.diseaseLabels.push({
                    diseaseId: item.labelId,
                    diseaseName: item.labelName,
                  });
                } else if (item.labelType === 3) {
                  this.circleForm.contentSymptoms.push({
                    symptomId: item.labelId,
                    symptomName: item.labelName,
                  });
                } else if (item.labelType === 4) {
                  this.circleForm.contentDrugs = res.nativeName;
                } else if (item.labelType === 5) {
                  this.circleForm.contentDrugNames.push({
                    drugId: item.labelId,
                    genericName: item.labelName,
                  });
                }
              });
            }
            // 解决第一次打开无图片问题
            this.dialogEditCircle = false;
            console.log("======EDITINIT", this.circleForm);
            this.dialogEditCircle = true;
          }, 500);
        });
      } else if (val.type === "check") {
        this.setStorage();
        this.removeStorage;
        sessionStorage.removeItem("activeName");

        // 跳转到文章编辑页面
        this.$router.push({
          path: `/circlepostmanage`,
          query: {
            circleId: val.val.communityId,
          },
        });
      } else if (val.type === "online") {
        jdh_qz_man_update({
          ...val?.val,

          status: 1,
        }).then(() => {
          this.searchParams.status = 1;
          this.activeName = "online";
          this.getArticleList();
          this.$message.success("上线成功");
        });
      } else if (val.type === "offline") {
        jdh_qz_man_update({
          ...val?.val,
          status: 2,
        }).then(() => {
          this.searchParams.status = 2;
          this.activeName = "offline";
          this.getArticleList();
          this.$message.success("下线成功");
        });
      }
      this.getTargetValue(val.val);
      this.getArticleList();
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.getArticleList("pageChange");
    },
    //获取列表
    getArticleList(type) {
      let params = {
        tenantId: this.tenantId,
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        businessId: this.getBusinessId(this.tenantId),
        status: this.searchParams.status,
        communityId: this.searchParams.communityId,
        labelName: this.searchParams.labelName,
        communityType: Object.keys(this.communityTypeMap).find(
          (key) =>
            this.communityTypeMap[key] === this.searchParams.communityType
        ),
        communityName: this.searchParams.communityName,
      };
      if (type == "search") {
        params = {
          ...params,
          pageNo: 1,
        };
      }
      console.log("==========PARAM", params);
      jdh_qz_man_page(params).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data?.map((item) => {
          item.realyName = item.contentUser?.nickName || "";
          item.communityTypeCheck = this.communityTypeMap[item.communityType];
          item.statusCheck = this.statusMap[item.status];
          item.onlineTime = this.formatDate(item.onlineTime);
          item.updateTime = this.formatDate(item.updateTime);
          item.createTime = this.formatDate(item.createTime);
          item.CommunityLabelInfo = item.communityLabelInfos
            ? item.communityLabelInfos
                ?.map((label) => label.labelName)
                .join(",")
            : "";
          if (
            item.communityConfJson &&
            JSON.parse(item.communityConfJson)?.module
          ) {
            let result = "";

            if (JSON.parse(item.communityConfJson)?.module?.video?.show) {
              result += "视频 ";
            }

            if (JSON.parse(item.communityConfJson)?.module?.community?.show) {
              result += "圈子 ";
            }

            if (JSON.parse(item.communityConfJson)?.module?.doctor?.show) {
              result += "问医生 ";
            }

            if (JSON.parse(item.communityConfJson)?.module?.recommend?.show) {
              result += "推荐好物 ";
            }

            if (JSON.parse(item.communityConfJson)?.module?.baike?.show) {
              result += "百科 ";
            }
            item.communityCatagory = item.communityConfJson ? result : "";
          }
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
        // this.tableData.tableList = [...mock]
      });
      // 获取各个审核状态的文章的数量
      // getAllArticleCounts(params).then(res => {
      //   this.allCount = res.allCount
      //   this.unAuditCount = res.unAuditCount
      //   this.passAuditCount = res.passAuditCount
      //   this.rejectCount = res.rejectCount
      //   this.offlineCount = res.offlineCount
      //   this.offlineUnAuditCount = res.offlineUnAuditCount
      // })
    },

    handleDialog(val) {
      this.reviewOfflineDialog = val;
    },
    getTargetValue(target) {
      this.targetValue = target;
    },
    // 获取天空之城数据 生成页面数据
    async queryFloorList() {
      // console.log('queryFloorList=======>', 33333);
      await request("jdh_laputa_queryFloorList", {
        functionId: "contentReviewOnOffLine",
        appId: "21557c5d3d0a4ec1b0184719022bb4b5",
        osName: "jdhwiki",
        venderId: null,
        inquiryTenancyId: null,
        version: 5,
      })
        .then(async (res) => {
          console.log("=======111", res);
          this.floorTransferDTOS = res?.cf?.floorTransferDTOS;
          console.log(
            res?.cf?.floorTransferDTOS[0],
            "contentAudit<----来了哥----->"
          );
          //  处理天空之城数据
          const cfgArray = res?.cf?.floorTransferDTOS[0].cfgList.filter(
            (item) => {
              if (item?.name == "manuDataCfg" && item?.checkbox == "common") {
                return true;
              }
              return false;
            }
          );
          // console.log(cfgArray, 'contentAudit<----来了哥----->cfgArray');
          // 整体配置数据
          let valueArray = JSON.parse(cfgArray[0].value)?.map((item) => {
            return JSON.parse(item?.value);
          });
          let fileterArray = [];
          let allShowSearchArr = [];
          // 所有配置的数据 包括 ids
          valueArray?.map((item) => {
            let filerItem = this.$commonJs.deepClone(item);
            if (!Array.isArray(filerItem?.selectedIDs)) {
              // 获取搜索筛选总的展示
              filerItem.selectItems = filerItem?.selectItems.filter(
                (subItem) => {
                  return subItem.isShow;
                }
              );
              fileterArray.push(filerItem);

              item.selectItems = item?.selectItems?.map((subItem) => {
                if (subItem.cfgID == 4000) {
                  this.businessChannelArr.push(subItem);
                }
                return subItem;
              });
              allShowSearchArr.push(item);
            } else {
              if (this.serverList?.length == 0) {
                // console.log('默认id', 'itemSelectedIDs========>');
                this.checkList = item?.selectedIDs;
              }
            }
          });

          // console.log(valueArray ,fileterArray, 'valueArray=====>|||||allShowSearchArr',allShowSearchArr);
          this.allSearchList = allShowSearchArr;
          // 搜索筛选弹框展示的数据
          this.searchFilterList = fileterArray;
          // console.log(valueArray, '拿到我配置的数据');

          // 页面上展示搜索
          let tempSelectList = [];
          this.checkList?.map((cItem) => {
            allShowSearchArr?.map((item) => {
              item?.selectItems?.map((subItem) => {
                if (cItem == subItem.cfgID) {
                  tempSelectList.push(subItem);
                }
              });
            });
          });
          // 显示的搜索弹框
          this.select = tempSelectList;
          // console.log(res, 'queryFloorList=====>|||||');
        })
        .catch((err) => {
          this.$message.error(err.msg || "查询失败");
        });
      // console.log('queryFloorList=======>', 44444);
    },
    // 查询用户配置
    async queryUserConfig() {
      // console.log('queryUserConfig=======>', 11111);
      await manListUserConfig({
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "1",
      }).then((res) => {
        if (res && res?.length > 0) {
          const userConfigBizDTO = res[0];
          this.configId = userConfigBizDTO?.configId;
          // console.log(this.configId,userConfigBizDTO, 'configId=====>',userConfigBizDTO?.value.split(','));
          this.checkList = userConfigBizDTO?.value
            .split(",")
            ?.map((item) => parseInt(item));
          this.serverList = userConfigBizDTO?.value
            .split(",")
            ?.map((item) => parseInt(item));
        }
        console.log("queryUserConfig=======>", res);
      });
      // console.log('queryUserConfig=======>', 222222);
    },
    // 用户保存配置
    async saveUserConfig(body) {
      await manSaveUserConfig(body).then((res) => {
        console.log(res, "用户保存了==========>");
      });
    },
    selectChenge(data) {
      this.isSelected = true;
      this.old = data;
    },

    // 查询分发范围
    getDistributionScope() {
      getDistributionScope(this);
    },
    getContentQuailty() {
      getContentQuailty(this);
    },
    // 搜索内容属性处理
    searchDataProcessing() {
      searchDataProcessing(this);
    },
    setCircle() {
      this.circleForm = {
        communityId: "",
        communityName: "",
        communityPicUrl: "",
        categoryName: "",
        category: "",
        categoryId: "",
        communityType: "",
        isHot: "",
        rankNum: "",
        status: "",
        video: true,
        circle: true,
        doctor: true,
        goods: true,
      };
      console.log("SETCIRCLE");
      this.dialogSetCircle = true;
    },
    changeTitlePic(data) {
      console.log("I AM INIT PIC", data);
      // data-封面组件的返回值
      this.titlePicUrl = data;
      // this.circleForm.communityPicUrl = data
      if (this.titlePicUrl && this.titlePicUrl.length > 0) {
        let url = this.titlePicUrl[0].url;
        // url 要截去的那部分 这个要从环境变量中取
        const imgHost = process.env.VUE_APP_imgHost;
        const startIndex = url.indexOf("jfs");
        if (startIndex !== -1) {
          const result = url.substring(startIndex);
          this.circleForm.communityPicUrl = result;
          console.log("=======", this.circleForm.communityPicUrl);
        } else {
          console.log('String "jfs" not found in the given string.');
        }
        console.log("=======DATA", data);
      } else {
        this.circleForm.communityPicUrl = "";
      }
    },
    handleConfirm() {
      this.$refs?.labelRef?.getFormLabelData?.(this.circleForm);
      console.log(">>>>>>>>>", this.circleForm);
      if (this.publicDomain) {
        if (
          !(
            this.circleForm.communityName &&
            this.circleForm.communityType &&
            (this.circleForm.video ||
              this.circleForm.circle ||
              this.circleForm.doctor ||
              this.circleForm.goods) &&
            (!this.circleForm.doctor ||
              (this.circleForm.doctor &&
                this.circleForm.doctorVal !== "" &&
                this.circleForm.doctorVal !== undefined)) &&
            (!this.circleForm.goods ||
              (this.circleForm.goods &&
                this.circleForm.goodsVal !== "" &&
                this.circleForm.goodsVal !== undefined))
          )
        ) {
          this.$message.error("请填写完整后提交");
        } else {
          jdh_qz_man_add({
            tenantId: this.tenantId,
            businessId: this.getBusinessId(this.tenantId),
            communityName: this.circleForm.communityName,
            communityPicUrl: this.circleForm.communityPicUrl
              ? this.circleForm.communityPicUrl
              : "",
            communityType: Object.keys(this.communityTypeMap).find(
              (key) =>
                this.communityTypeMap[key] === this.circleForm.communityType
            ),
            isHot: this.circleForm.isHot,
            rankNum:
              this.circleForm.rankNum == 0 && !this.circleForm.categoryId
                ? null
                : this.circleForm.rankNum,
            categoryId: this.circleForm.categoryId,
            communityLabelInfos: [
              // ...this.circleForm.extensionContentLabels?.map(item => ({
              //   ...item, // 保留 item 的其他属性
              //   labelType: 1 // 新增 labelType 属性
              //  })),
              ...this.circleForm.extensionContentLabels?.map((item) => ({
                labelId: item.id, // 只保留 id 属性
                labelName: item.name, // 只保留 name 属性
                labelType: 1, // 新增 labelType 属性
              })),
              // {labelType:2,labelId:1,labelName:JSON.stringify(this.circleForm.extensionContentLabels)},
              // {labelType:3,labelId:1,labelName:JSON.stringify(this.circleForm.extensionContentLabels)},
            ],
            communityConfJson: {
              module: {
                video: {
                  //视频
                  show: true, //是否展示
                  contentId: this.circleForm.contentId, //视频内容id
                  mainVideoUrl: this.circleForm.mainVideoUrl, //主视频url
                  mainVideoTitle: this.circleForm.mainVideoTitle,
                  keywords: this.circleForm.videoVal, //视频关键词，多个用","分隔
                },
                community: {
                  //圈子
                  show: true, //是否展示
                },
                doctor: {
                  //医生
                  show: true, //是否展示
                  keywords: this.circleForm.doctorVal, //医生搜索关键词，多个用","分隔
                },
                recommend: {
                  //推荐好物
                  show: true, //是否展示
                  keywords: this.circleForm.goodsVal, //商品搜索关键词，多个用","分隔
                },
                baike: {
                  //百科
                  show: true, //是否展示
                  keywords: this.circleForm.baikeVal, //商品搜索关键词，多个用","分隔
                },
              },
            },
          })
            .then((res) => {
              this.dialogSetCircle = false;
              this.$message.success("新建成功");
              this.getArticleList();
            })
            .catch((err) => {
              this.$message.error(err.msg);
            });
        }
      } else {
        // 夜迷
        if (!(this.circleForm.communityName && this.circleForm.communityType)) {
          this.$message.error("请填写完整后提交");
        } else {
          jdh_qz_man_add({
            tenantId: this.tenantId,
            businessId: this.getBusinessId(this.tenantId),
            communityName: this.circleForm.communityName,
            communityPicUrl: this.circleForm.communityPicUrl
              ? this.circleForm.communityPicUrl
              : "",
            communityType: Object.keys(this.communityTypeMap).find(
              (key) =>
                this.communityTypeMap[key] === this.circleForm.communityType
            ),
          })
            .then((res) => {
              this.dialogSetCircle = false;
              this.$message.success("新建成功");
              this.getArticleList();
            })
            .catch((err) => {
              this.$message.error(err.msg);
            });
        }
      }
    },
    handleReset() {
      this.activeName = "all";
      this.searchParams = {
        communityName: "",
        communityId: "",
        communityType: "",
      };
      this.getArticleList();
    },
    handleSearch() {
      this.getArticleList("search");
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    handleSave() {
      if (this.publicDomain) {
        if (
          !(
            this.circleForm.communityName &&
            this.circleForm.communityType &&
            (this.circleForm.video ||
              this.circleForm.circle ||
              this.circleForm.doctor ||
              this.circleForm.goods) &&
            (!this.circleForm.doctor ||
              (this.circleForm.doctor &&
                this.circleForm.doctorVal !== "" &&
                this.circleForm.doctorVal !== undefined)) &&
            (!this.circleForm.goods ||
              (this.circleForm.goods &&
                this.circleForm.goodsVal !== "" &&
                this.circleForm.goodsVal !== undefined))
          )
        ) {
          this.$message.error("请填写完整后提交");
        } else {
          this.$refs?.labelRef?.getFormLabelData?.(this.circleForm);
          if (sessionStorage.getItem("changeVideo")) {
            this.circleForm.contentId = JSON.parse(
              sessionStorage.getItem("changeVideo")
            )?.videoId;
            this.circleForm.mainVideoUrl = JSON.parse(
              sessionStorage.getItem("changeVideo")
            )?.playUrl;
            this.circleForm.mainVideoTitle = JSON.parse(
              sessionStorage.getItem("changeVideo")
            )?.title;
          } else {
            this.circleForm.contentId = this.circleForm.videoAll[0]?.videoId;
            this.circleForm.mainVideoUrl = this.circleForm.videoAll[0]?.playUrl;
            this.circleForm.mainVideoTitle = this.circleForm.videoAll[0]?.title;
          }
          // module
          let parsedModules = {};
          if (this.circleForm.video) {
            parsedModules.video = {
              show: this.circleForm.video,
              contentId: this.circleForm.contentId,
              keywords: this.circleForm.videoVal,
            };
          }

          if (this.circleForm.circle) {
            parsedModules.community = {
              show: this.circleForm.circle,
            };
          }

          if (this.circleForm.doctor) {
            parsedModules.doctor = {
              show: this.circleForm.doctor,
              keywords: this.circleForm.doctorVal,
            };
          }

          if (this.circleForm.goods) {
            parsedModules.recommend = {
              show: this.circleForm.goods,
              keywords: this.circleForm.goodsVal,
            };
          }

          if (this.circleForm.baike) {
            parsedModules.baike = {
              show: this.circleForm.baike,
              keywords: this.circleForm.baikeVal,
            };
          }

          if (this.circleForm.instruction) {
            parsedModules.instruction = {
              show: this.circleForm.instruction,
            };
          }

          if (this.circleForm.priceParity) {
            parsedModules.priceParity = {
              show: this.circleForm.priceParity,
            };
          }
          console.log("=== my circle", parsedModules);
          jdh_qz_man_update({
            ...this.currentDetail,
            tenantId: this.tenantId,
            businessId: this.getBusinessId(this.tenantId),
            communityId: this.circleForm.communityId,
            communityName: this.circleForm.communityName,
            communityPicUrl: this.circleForm.communityPicUrl
              ? this.circleForm.communityPicUrl
              : "",
            communityType: Object.keys(this.communityTypeMap).find(
              (key) =>
                this.communityTypeMap[key] === this.circleForm.communityType
            ),
            categoryId: this.circleForm.categoryId,
            isHot: this.circleForm.isHot,
            rankNum: this.circleForm.rankNum,
            communityLabelInfos: [
              ...this.circleForm?.extensionContentLabels?.map((item) => ({
                labelId: item.id, // 只保留 id 属性
                labelName: item.name, // 只保留 name 属性
                labelType: 1, // 新增 labelType 属性
              })),
              ...this.circleForm?.diseaseLabels?.map((item) => ({
                labelId: item.diseaseId, // 只保留 id 属性
                labelName: item.diseaseName, // 只保留 name 属性
                labelType: 2, // 新增 labelType 属性
              })),
              ...this.circleForm?.contentSymptoms?.map((item) => ({
                labelId: item.symptomId, // 只保留 id 属性
                labelName: item.symptomName, // 只保留 name 属性
                labelType: 3, // 新增 labelType 属性
              })),
              // todo: 药品圈
              // {
              //   labelId: 0, // 只保留 id 属性
              //   labelName: this.circleForm?.nativeName, // 只保留 name 属性
              //   labelType: 4 // 新增 labelType 属性
              // },
              // ...this.circleForm?.contentDrugNames?.map(item => ({
              //   labelId: item.drugId, // 只保留 id 属性
              //   labelName: item.genericName, // 只保留 name 属性
              //   labelType: 5 // 新增 labelType 属性
              // })),
            ],
            communityConfJson: {
              module: parsedModules,
            },
          })
            .then((res) => {
              this.getArticleList();
              console.log(res);
              this.$message.success("保存成功");
              sessionStorage.removeItem("changeVideo");
              if (res) {
                this.dialogEditCircle = false;
              }
              this.$message.success("保存成功");
            })
            .catch((err) => {
              this.$message.error("保存失败");
            });
        }
      } else {
        // 夜迷
        if (!(this.circleForm.communityName && this.circleForm.communityType)) {
          this.$message.error("请填写完整后提交");
        } else {
          this.$refs?.labelRef?.getFormLabelData?.(this.circleForm);
          if (sessionStorage.getItem("changeVideo")) {
            this.circleForm.contentId = JSON.parse(
              sessionStorage.getItem("changeVideo")
            )?.videoId;
            this.circleForm.mainVideoUrl = JSON.parse(
              sessionStorage.getItem("changeVideo")
            )?.playUrl;
            this.circleForm.mainVideoTitle = JSON.parse(
              sessionStorage.getItem("changeVideo")
            )?.title;
          } else {
            this.circleForm.contentId = this.circleForm.videoAll[0]?.videoId;
            this.circleForm.mainVideoUrl = this.circleForm.videoAll[0]?.playUrl;
            this.circleForm.mainVideoTitle = this.circleForm.videoAll[0]?.title;
          }
          // module
          let parsedModules = {};
          if (this.circleForm.video) {
            parsedModules.video = {
              show: this.circleForm.video,
              contentId: this.circleForm.contentId,
              keywords: this.circleForm.videoVal,
            };
          }

          if (this.circleForm.circle) {
            parsedModules.community = {
              show: this.circleForm.circle,
            };
          }

          if (this.circleForm.doctor) {
            parsedModules.doctor = {
              show: this.circleForm.doctor,
              keywords: this.circleForm.doctorVal,
            };
          }

          if (this.circleForm.goods) {
            parsedModules.recommend = {
              show: this.circleForm.goods,
              keywords: this.circleForm.goodsVal,
            };
          }

          if (this.circleForm.baike) {
            parsedModules.baike = {
              show: this.circleForm.baike,
              keywords: this.circleForm.baikeVal,
            };
          }

          if (this.circleForm.instruction) {
            parsedModules.instruction = {
              show: this.circleForm.instruction,
            };
          }

          if (this.circleForm.priceParity) {
            parsedModules.priceParity = {
              show: this.circleForm.priceParity,
            };
          }
          console.log("=== my circle", parsedModules);
          jdh_qz_man_update({
            ...this.currentDetail,
            tenantId: this.tenantId,
            businessId: this.getBusinessId(this.tenantId),
            communityId: this.circleForm.communityId,
            communityName: this.circleForm.communityName,
            communityPicUrl: this.circleForm.communityPicUrl
              ? this.circleForm.communityPicUrl
              : "",
            communityType: Object.keys(this.communityTypeMap).find(
              (key) =>
                this.communityTypeMap[key] === this.circleForm.communityType
            ),
          })
            .then((res) => {
              this.getArticleList();
              console.log(res);
              this.$message.success("保存成功");
              sessionStorage.removeItem("changeVideo");
              if (res) {
                this.dialogEditCircle = false;
              }
              this.$message.success("保存成功");
            })
            .catch((err) => {
              this.$message.error("保存失败");
            });
        }
      }
    },
    getCategoryList() {
      jdh_qz_man_queryCategorys({
        tenantId: this.tenantId,
        businessId: this.getBusinessId(this.tenantId),
      }).then((res) => {
        this.categoryList = res;
      });
    },
    changeDiseaseLabels(data) {
      // 拿到疾病标签
      this.circleForm.diseaseLabels = data;
    },
    //疾病标签是否选中
    ischeckedDiseaseLabel(diseaseId, labelId) {
      let arr = this.circleForm.diseaseLabels || [];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].diseaseId != diseaseId) {
          continue;
        }
        var labels = arr[i].diseaseEntry || [];
        for (var j = 0; j < labels.length; j++) {
          if (labelId == labels[j].id) {
            return true;
          }
        }
      }
      return false;
    },
    // 症状标签
    changeSymptomLabels(data) {
      console.log(
        "🚀 ~ file: index.vue:228 ~ changeSymptomLabels ~ data:",
        data
      );
      this.circleForm.contentSymptoms = data;
    },
    handleLabelChange(newLabelValue) {
      console.log("标签值已更改:", newLabelValue);
      // 处理标签变化的逻辑
    },
    changeGenericNameLabels(data) {
      console.log("=======!", data);
      this.circleForm.contentDrugNames = data;
    },
    changeVideos(data) {
      console.log("=======!");
      this.circleForm.contentId = data[0]?.videoId;
      this.circleForm.mainVideoUrl = data[0]?.playUrl;
      this.circleForm.mainVideoTitle = data[0]?.title;
    },
    changeEncyclopediaLabels(data) {
      this.circleForm.contentSkus = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-audit-tabel {
  position: relative;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;

  .import-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 11;

    .redTag {
      color: red;
    }
  }
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

:deep(.el-textarea__inner) {
  min-height: 130px !important;
  resize: none;
}

:deep(.el-form-item) {
  margin-bottom: 22px;
}

:deep(.modal-body) {
  margin-top: 30px;
}

.reasonDom {
  padding: 0 30px;
  height: 100px;
  line-height: 20px;
  font-size: 14px;
  color: rgba(44, 52, 67, 1);
  /*overflow: hidden;*/
  overflow-y: auto;
  max-height: 150px;
}

.freezeDom {
  /*margin-top: 30px;*/
  .freezeInp {
    max-height: 130px;
    max-width: 276px;

    // overflow: hidden;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  .mar-top30 {
    margin-top: 30px;
  }
}

.importBtn {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin-left: 5px;
}

.exportBtn {
  margin-left: 5px;

  span {
    margin-top: 5px;
    display: block;
    color: #abaaaa;
  }
}

.dropDown {
  margin-left: 10px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  height: 32px;
  line-height: 32px;
}

.input-group {
  display: flex;
  gap: 10px;
}

.button-group {
  display: flex;
  gap: 10px;
}

/* 使用 CSS 选择器来修改星号颜色 */
:deep(.custom-required .el-form-item__label) {
  position: relative;
}

:deep(.custom-required .el-form-item__label::before) {
  content: "*";
  color: red;
  position: absolute;
  left: 40px;
  /* 根据需要调整位置 */
}

:deep(.el-form-item__label) {
  line-height: 30px;
}

:deep(.el-form-item) {
  width: 100%;
}
</style>
